//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props:['receivedData'],
    created(){
        this.data.categories= this.receivedData.categories
        this.data.brands= this.receivedData.brands
        this.data.cities= this.receivedData.cities
    },
    data(){
        return {
            data:{
                categories: [],
                brands: [],
                cities: []
            },
            category: '',
            brand: '',
            city: ''
        }
    },
    methods:{
        async selectCategory(){
            this.brand = ''
            if(this.category){
                this.data.brands = await this.$axios.$get(`filter/brands/${this.category}`)
            }
        },
    }
}
